import AutoNumeric from 'autonumeric';

const customFormInp = (() => {
  let currentTab = 0; // Current tab is set to be the first tab (0)

  const customInputOnlyNumber = () => {
    // const customInputElements = document.querySelectorAll('.custom-value-only-number');
    // customInputElements.forEach(input => {
    //   input.addEventListener('input', () => {
    //     input.value = input.value.replace(/[^0-9]/g, '');
    //   });
    // });
  };

  const customInputTL = () => {
    // const customInputElements = document.querySelectorAll('.custom-value-tl');
    // customInputElements.forEach(input => {
    //   new AutoNumeric(input, {
    //     digitGroupSeparator: '.',
    //     decimalCharacter: ',',
    //     currencySymbol: ' TL',
    //     currencySymbolPlacement: 's',
    //     decimalPlaces: 0,
    //     minimumValue: '0',
    //     // emptyInputBehavior: 'zero',
    //   });
    // });
  };

  const showTab = (n) => {
    // This function will display the specified tab of the form...
    const form = document.querySelector('.payment-info-form');
    if (!form) return;
    
    const x = form.getElementsByClassName("tab");
    // console.log('Found tabs:', x.length);
    for (let i = 0; i < x.length; i++) {
      // console.log('Tab', i, ':', x[i]);
    }
    
    if (x.length === 0) return;
    
    // Hide all tabs first
    for (let i = 0; i < x.length; i++) {
      x[i].style.display = "none";
    }
    
    // Show the current tab
    x[n].style.display = "block";
    
    // Fix the Previous/Next buttons:
    const prevBtn = form.querySelector("#prevBtn");
    const nextBtn = form.querySelector("#nextBtn");
    
    if (prevBtn) {
      if (n == 0) {
        prevBtn.style.display = "none";
      } else {
        prevBtn.style.display = "flex";
      }
    }
    
    if (nextBtn) {
      const svgIcon = '<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 8.0026H0M20 8.0026L13.3333 1.33594M20 8.0026L13.3333 14.6693" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      
      // n is 0-indexed, but data-step attributes are 1-indexed, so we need n+1
      // Check for data-step attribute for current step
      const nextBtnLabel = nextBtn.getAttribute(`data-step-${n}`);
      
      if (n == (x.length - 1)) {
        // Last tab - use custom label or default to "Ödemeye Geçin"
        if (nextBtnLabel && nextBtnLabel.trim() !== '') {
          nextBtn.innerHTML = `<span>${nextBtnLabel}</span>${svgIcon}`;
        } else {
          nextBtn.innerHTML = `<span>Ödemeye Geçin</span>${svgIcon}`;
        }
      } else {
        // Not last tab - use custom label if available, otherwise default to "Devam Edin"
        if (nextBtnLabel && nextBtnLabel.trim() !== '') {
          nextBtn.innerHTML = `<span>${nextBtnLabel}</span>${svgIcon}`;
        } else {
          nextBtn.innerHTML = `<span>Devam Edin</span>${svgIcon}`;
        }
      }
      
      if (n == (x.length - 1)) {
        nextBtn.classList.add('payment-form-submit-btn');
      } else {
        nextBtn.classList.remove('payment-form-submit-btn');
      }
    }
    
    // Run a function that will display the correct step indicator:
    fixStepIndicator(n);
  };

  const nextPrev = (n) => {
    // This function will figure out which tab to display
    const form = document.querySelector('.payment-info-form');
    if (!form) return false;
    
    const x = form.getElementsByClassName("tab");
    if (x.length === 0) return false;
    
    // console.log('Current tab:', currentTab, 'Total tabs:', x.length, 'Direction:', n);
    
    // Exit the function if any field in the current tab is invalid:
    if (n == 1 && !validateForm()) return false;
    
    // Calculate the new tab index
    const newTabIndex = currentTab + n;
    
    // console.log('New tab index:', newTabIndex);
    
    // Check if we're trying to go beyond the available tabs
    if (newTabIndex < 0 || newTabIndex >= x.length) {
      // If trying to go beyond the last tab, submit the form
      if (newTabIndex >= x.length) {
        // console.log('Reached end of form, submitting...');
        // console.log('Current URL:', window.location.href);
        
        // Check if URL has a hash character
        if (window.location.hash) {
          // console.log('URL has hash, preventing form submission');
          return false;
        }
        
        // Only allow submission if we're on the last tab
        if (currentTab === (x.length - 1)) {
          // Show alert when on last tab and button is clicked
          // alert('Son tab\'a ulaştınız!');
          
          // Submit the form
          // form.submit();
        } else {
          // alert('Lütfen önce tüm adımları tamamlayın!');
          return false;
        }
        return false;
      }
      // If trying to go before the first tab, do nothing
      return false;
    }
    
    // Hide the current tab:
    x[currentTab].style.display = "none";
    
    // Update current tab
    currentTab = newTabIndex;
    
    // Display the correct tab:
    showTab(currentTab);
  };

  const validatePhoneNumber = (phoneValue) => {
    // Telefon numarası validasyonu: içindeki rakam sayısı en az 10 olmalı
    // +90 ile başlamasına gerek yok, sadece rakam sayısı kontrol edilir
    
    if (!phoneValue || phoneValue.trim() === '') {
      return false;
    }
    
    // Tüm karakterlerden sadece rakamları çıkar
    const numbersOnly = phoneValue.replace(/\D/g, '');
    
    // En az 10 rakam olmalı (10'dan küçük olamaz)
    if (numbersOnly.length < 10) {
      return false;
    }
    
    return true;
  };

  const validateForm = () => {
    // This function deals with validation of the form fields
    const form = document.querySelector('.payment-info-form');
    if (!form) return false;
    
    const x = form.getElementsByClassName("tab");
    if (x.length === 0) return false;
    
    // Get all form elements: input, select, and textarea
    const inputs = x[currentTab].getElementsByTagName("input");
    const selects = x[currentTab].getElementsByTagName("select");
    const textareas = x[currentTab].getElementsByTagName("textarea");
    
    // Combine all form elements into a single array
    const formFields = [...inputs, ...selects, ...textareas];
    
    let valid = true;
    
    // A loop that checks every form field in the current tab:
    for (let i = 0; i < formFields.length; i++) {
      const field = formFields[i];
      
      // Skip checkbox and radio inputs (they have different validation logic)
      if (field.type === 'checkbox' || field.type === 'radio') {
        continue;
      }
      
      // Skip fields that are inside an inactive inner tab
      const innerTab = field.closest('.a-tab-content');
      if (innerTab && !innerTab.classList.contains('tab-active')) {
        continue;
      }
      
      // Remove existing validation classes first
      field.classList.remove('is-error', 'is-valid');
      
      // Check if field is required
      if (field.hasAttribute('required')) {
        if (field.value == "" || field.value == null) {
          // Required field is empty - add error class
          field.classList.add('is-error');
          valid = false;
        } else {
          // Special validation for phone number fields (type="tel")
          if (field.type === 'tel') {
            if (!validatePhoneNumber(field.value)) {
              // Phone number format is invalid
              field.classList.add('is-error');
              valid = false;
            } else {
              // Phone number is valid
              field.classList.add('is-valid');
            }
          } else {
            // Required field is filled - add valid class
            field.classList.add('is-valid');
          }
        }
      } else {
        // Non-required field - check phone format if it's a tel input with value
        if (field.type === 'tel' && field.value && field.value.trim() !== '') {
          if (!validatePhoneNumber(field.value)) {
            // Phone number format is invalid (but field is not required, so don't block form)
            field.classList.add('is-error');
          } else {
            field.classList.add('is-valid');
          }
        } else {
          // Non-required field - always add valid class
          field.classList.add('is-valid');
        }
      }
    }
    
    return valid; // return the valid status
  };

  const fixStepIndicator = (n) => {
    // This function removes the "active" class of all steps...
    const form = document.querySelector('.payment-info-form');
    if (!form) return;
    
    const x = form.getElementsByClassName("step");
    
    for (let i = 0; i < x.length; i++) {
      // Remove both "active" and "finish" classes
      x[i].classList.remove("active", "finish");
    }
    
    //... and adds the "active" class on the current step:
    if (x[n]) {
      x[n].classList.add("active");
    }
    
    // Add "finish" class to all previous steps
    for (let i = 0; i < n; i++) {
      if (x[i]) {
        x[i].classList.add("finish");
      }
    }
  };

  const stepForm = () => {
    const form = document.querySelector('.payment-info-form');
    if (!form) return;
    
    // Check if form has tabs
    const x = form.getElementsByClassName("tab");
    if (x.length === 0) return;
    
    // Function to check if form can be submitted
    const canSubmitForm = () => {
      return currentTab === (x.length - 1);
    };
    
    // Prevent default form submission unless on last tab and validated
    // Use capture phase to ensure our handler runs first
    const handleFormSubmit = (e) => {
      const targetForm = e.target;
      
      // Check if this is the payment-info-form or order-form
      const isPaymentForm = targetForm.classList.contains('payment-info-form') || 
                           targetForm.id === 'order-form' ||
                           targetForm.closest('.payment-info-form') === form ||
                           targetForm.querySelector('.payment-info-form') === form;
      
      if (isPaymentForm) {
        // If not on last tab, prevent submission
        if (!canSubmitForm()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
        
        // If on last tab, validate form before allowing submission
        if (canSubmitForm()) {
          if (!validateForm()) {
            // Form validation failed - prevent submission
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
          // Form is valid - allow submission
        }
      }
    };
    
    // Add listener to the form itself
    form.addEventListener('submit', handleFormSubmit, true);
    
    // Also add listener at document level to catch all form submissions
    // This will catch form.submit() calls from jQuery
    const documentSubmitHandler = (e) => {
      const targetForm = e.target;
      
      // Check if this is the payment-info-form or order-form
      const paymentForm = document.querySelector('.payment-info-form');
      if (!paymentForm) return;
      
      const formTabs = paymentForm.getElementsByClassName("tab");
      if (formTabs.length === 0) return;
      
      const isPaymentForm = targetForm === paymentForm || 
                           targetForm.id === 'order-form' ||
                           targetForm.classList.contains('payment-info-form') ||
                           targetForm.closest('.payment-info-form') === paymentForm ||
                           paymentForm.querySelector('#order-form') === targetForm;
      
      if (isPaymentForm) {
        // If not on last tab, prevent submission
        if (currentTab !== (formTabs.length - 1)) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
        
        // If on last tab, validate form before allowing submission
        if (currentTab === (formTabs.length - 1)) {
          if (!validateForm()) {
            // Form validation failed - prevent submission
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
          // Form is valid - allow submission
        }
      }
    };
    
    document.addEventListener('submit', documentSubmitHandler, true);
    
    // Initialize the form
    showTab(currentTab);
    
    // Add event listeners for buttons
    const prevBtn = form.querySelector("#prevBtn");
    const nextBtn = form.querySelector("#nextBtn");
    
    if (prevBtn) {
      // Ensure button is not a submit button
      prevBtn.type = "button";
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        nextPrev(-1);
      });
    }
    
    if (nextBtn) {
      // Ensure button is not a submit button
      nextBtn.type = "button";
      
      // Add click handler with capture phase to intercept before jQuery
      const handleNextBtnClick = (e) => {
        // If not on last tab, go to next tab
        if (!canSubmitForm()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          nextPrev(1);
          return false;
        }
        
        // If on last tab, validate form before allowing submission
        if (canSubmitForm()) {
          if (!validateForm()) {
            // Form validation failed - prevent submission
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
          // Form is valid - allow event to proceed to jQuery handlers
          return;
        }
      };
      
      nextBtn.addEventListener('click', handleNextBtnClick, true); // Use capture phase to run before jQuery handlers
      
      // Also add document-level listener to catch delegated jQuery events
      // This will catch $(document).on('click', '#nextBtn', ...) handlers
      const documentClickHandler = (e) => {
        const clickedBtn = e.target.closest('#nextBtn');
        if (clickedBtn && clickedBtn === nextBtn) {
          const paymentForm = document.querySelector('.payment-info-form');
          if (!paymentForm) return;
          
          const formTabs = paymentForm.getElementsByClassName("tab");
          if (formTabs.length === 0) return;
          
          // If not on last tab, go to next tab
          if (currentTab !== (formTabs.length - 1)) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            nextPrev(1);
            return false;
          }
          
          // If on last tab, validate form before allowing submission
          if (currentTab === (formTabs.length - 1)) {
            if (!validateForm()) {
              // Form validation failed - prevent submission
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              return false;
            }
            // Form is valid - allow event to proceed to jQuery handlers
            return;
          }
        }
      };
      
      document.addEventListener('click', documentClickHandler, true);
    }
  };

  const creditCartValue = () => {
    const creditCartValueElements = document.querySelectorAll('.custom-value-card-number');
    creditCartValueElements.forEach(input => {
      input.addEventListener('input', (e) => {
        // Sadece sayıları al
        let value = e.target.value.replace(/[^0-9]/g, '');
        
        // Maksimum 16 hane
        if (value.length > 16) {
          value = value.slice(0, 16);
        }
        
        // 4'lü gruplar halinde formatla
        const groups = value.match(/.{1,4}/g);
        if (groups) {
          e.target.value = groups.join(' ');
        } else {
          e.target.value = value;
        }
      });
      
      // Sadece sayı girişine izin ver
      input.addEventListener('keypress', (e) => {
        const charCode = e.which ? e.which : e.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          e.preventDefault();
        }
      });
    });
  };
  
  const creditCartDate = () => {
    const creditCartDateElements = document.querySelectorAll('.custom-value-card-date');
    creditCartDateElements.forEach(input => {
      input.addEventListener('input', (e) => {
        // Sadece sayıları al
        let value = e.target.value.replace(/[^0-9]/g, '');
        
        // Maksimum 4 hane (ay + yıl)
        if (value.length > 4) {
          value = value.slice(0, 4);
        }
        
        // Ay kontrolü (01-12)
        if (value.length >= 2) {
          const month = parseInt(value.slice(0, 2));
          if (month < 1 || month > 12) {
            value = value.slice(0, 1);
          }
        }
        
        // Formatla: MM / YYYY
        if (value.length >= 2) {
          const month = value.slice(0, 2);
          const year = value.slice(2);
          e.target.value = month + (year ? ' / ' + year : '');
        } else {
          e.target.value = value;
        }
      });
      
      // Sadece sayı girişine izin ver
      input.addEventListener('keypress', (e) => {
        const charCode = e.which ? e.which : e.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          e.preventDefault();
        }
      });
    });
    // console.log('Credit cart date');
  };

  const init = () => {
    customInputOnlyNumber();
    customInputTL();
    stepForm();
    creditCartValue();
    creditCartDate();
  };

  return {
    init,
  };
})();

export default customFormInp;
